import React from 'react';

import { parseAsStringEnum, useQueryState } from 'nuqs';

import { Dropdown, DropdownItem } from '@uikit';

import { Sort } from '@uikit/icons/Sort';

import {
  REWARD_POOLS_READABLE_SEARCH_PARAMS_ORDER_BY,
  RewardPoolsReadableSearchParamsOrderBy,
} from '@shared/api/rewardPools';

export const sortByFiltersOptionsInOrder: {
  value: RewardPoolsReadableSearchParamsOrderBy;
  label: string;
}[] = [
  {
    value: REWARD_POOLS_READABLE_SEARCH_PARAMS_ORDER_BY.NEWEST,
    label: 'Newest',
  },
  {
    value: REWARD_POOLS_READABLE_SEARCH_PARAMS_ORDER_BY.ENDING_SOON,
    label: 'Ending Soon',
  },
];

export const DEFAULT_SORT_BY_FILTER_VALUE = REWARD_POOLS_READABLE_SEARCH_PARAMS_ORDER_BY.NEWEST;

export const useRewardPoolsOrderByFilterQueryState = () => {
  return useQueryState(
    'order',
    parseAsStringEnum<RewardPoolsReadableSearchParamsOrderBy>(
      Object.values(REWARD_POOLS_READABLE_SEARCH_PARAMS_ORDER_BY),
    )
      .withDefault(DEFAULT_SORT_BY_FILTER_VALUE)
      .withOptions({ clearOnDefault: true }),
  );
};

const RewardPoolsOrderByFilter = () => {
  const [filter, setFilter] = useRewardPoolsOrderByFilterQueryState();
  const activeOption =
    sortByFiltersOptionsInOrder.find((option) => option.value === filter) ||
    sortByFiltersOptionsInOrder[0];

  return (
    <Dropdown
      variant="secondary"
      placement="bottom-end"
      trigger={
        <button className="msq-btn msq-btn-lg whitespace-nowrap msq-btn-secondary">
          <Sort className="msq-btn-icon msq-btn-icon-left" />
          {activeOption?.label}
        </button>
      }
    >
      {sortByFiltersOptionsInOrder.map(({ value, label }) => (
        <DropdownItem
          onClick={() => {
            setFilter(value);
          }}
          variant="secondary"
          key={value}
          isActive={filter === value}
          label={label}
        />
      ))}
    </Dropdown>
  );
};

export default RewardPoolsOrderByFilter;
